import React, { useState, useEffect } from "react";
import {
	Modal,
	Form,
	Select,
	DatePicker,
	Input,
	Button,
	message,
	Typography,
} from "antd";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

const { TextArea } = Input;
const { Option } = Select;

const EditDepartmentModal = ({
	visible,
	onCancel,
	onSuccess,
	userId,
	currentDepartmentId,
}) => {
	const isMobile = useIsMobile();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [departments, setDepartments] = useState([]);

	useEffect(() => {
		if (visible) {
			getDepartments();
			form.setFieldsValue({
				changed_department: currentDepartmentId,
				changed_date: dayjs(),
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- form is stable
	}, [visible, currentDepartmentId]);

	const getDepartments = async () => {
		try {
			const response = await useAxios.get(
				"/department/departments/"
			);
			if (response.status === 200) {
				setDepartments(response.data);
			}
		} catch (error) {
			message.error(
				"소속기관 목록을 불러오는데 실패했습니다."
			);
		}
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();

			const selectedDepartment = departments.find(
				(d) => d.id === values.changed_department
			);

			const updateData = {
				affiliated_department_id:
					values.changed_department,
				department_change: {
					changed_date:
						values.changed_date.format(
							"YYYY-MM-DD"
						),
					changed_department:
						selectedDepartment?.name || "",
					reason: values.reason || "",
				},
			};

			const response = await useAxios.put(
				`/users/update-affiliated-department/${userId}/`,
				updateData
			);

			if (response.status === 200) {
				message.success(
					"소속기관이 성공적으로 수정되었습니다."
				);
				onSuccess();
				form.resetFields();
			}
		} catch (error) {
			message.error("소속기관 수정에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title="소속기관 수정"
			open={visible}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					취소
				</Button>,
				<Button
					key="submit"
					type="primary"
					loading={loading}
					onClick={handleSubmit}>
					수정
				</Button>,
			]}
			width={500}>
			<Form form={form} layout="vertical">
				<Form.Item
					name="changed_department"
					label="소속기관"
					rules={[
						{
							required: true,
							message: "소속기관을 선택해주세요",
						},
					]}>
					<Select placeholder="소속기관 선택">
						{departments.map(
							(department) => (
								<Option
									key={
										department.id
									}
									value={
										department.id
									}>
									{
										department.name
									}
								</Option>
							)
						)}
					</Select>
				</Form.Item>

				<Form.Item
					name="changed_date"
					label="변경일"
					rules={[
						{
							required: true,
							message: "변경일을 선택해주세요",
						},
					]}>
					<DatePicker
						inputReadOnly={isMobile}
						style={{ width: "100%" }}
						format="YYYY-MM-DD"
						placeholder="변경일 선택"
					/>
				</Form.Item>

				<Form.Item name="reason" label="변경 사유">
					<TextArea
						rows={3}
						placeholder="변경 사유를 입력해주세요"
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditDepartmentModal;
